import React from 'react';
import { Link } from 'react-router-dom';
import FormattedNumber from '../components/FormattedNumber.jsx';

const getOrderType = (order) => {
    switch (order.type) {
        case 'return':
            return 'Return';
        case 'sop':
            return 'SOP';
        case 'pif':
            return 'Play It Forward';
        case 'standard':
        default:
            return 'Purchase';
    }
};

const OrdersTable = (props) => {
    let { orders } = props;
    return (
        <table>
            <thead>
                <tr>
                    <th>Order Number</th>
                    <th>Order Type</th>
                    <th>PO Number</th>
                    <th>Order Date</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                {!orders.length && (
                    <tr>
                        <td colSpan={4}>No Orders</td>
                    </tr>
                )}
                {orders.map((order) => {
                    return (
                        <tr key={order.order_number}>
                            <td>
                                <Link to={`/orders/${order.order_number}`}>{order.order_number}</Link>
                            </td>
                            <td>{getOrderType(order)}</td>
                            <td>{order.po}</td>
                            <td>{new Date(order.submitted_date).toLocaleDateString('en-US')}</td>
                            <td>
                                <FormattedNumber value={order.order_total} currency={'USD'} />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default OrdersTable;
